import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useCallback, useState } from 'react';
import { COMPOSER_MODULE } from '~/constants/common/MfeModules';
import { selectIsMfeReady, useMfeLoadStore } from '~/state/common/MfeLoadState';

const selectIsComposerMfeReady = selectIsMfeReady(COMPOSER_MODULE);

// Fallback for pages that don't mount MfeEventsListener (Home).
export default function useComposerReadyState() {
  const isReadyFromStore = useMfeLoadStore(selectIsComposerMfeReady);
  const [isReadyFromListener, setReadyFromListener] = useState(false);

  useCoreEvents(
    eventNames.composer.mfe.ready,
    useCallback(({ source }) => {
      if (source !== 'composer') return;

      setReadyFromListener(true);
    }, [])
  );
  useCoreEvents(
    eventNames.composer.mfe.unready,
    useCallback(({ source }) => {
      if (source !== 'composer') return;

      setReadyFromListener(false);
    }, [])
  );

  return isReadyFromStore || isReadyFromListener;
}
